// src/routes/StorePickupRoutes.jsx
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import PermissionRoute from './PermissionRoute';

import StorePickupOrdersPage from '../pages/store-pickup/StorePickupOrdersPage';

const StorePickupRoutes = () => {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <PermissionRoute requiredPermission="view_store_pickup_orders">
            <StorePickupOrdersPage />
          </PermissionRoute>
        }
      />
    </Routes>
  );
};

export default StorePickupRoutes;
